import React, { FC } from "react";
import {
  Bar,
  BarChart,
  CartesianGrid,
  Cell,
  Text,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

import { IgTypography } from "@intelligems/ig-theme";
import { Grid } from "@mui/material";

import { useGraphValueFormatter } from "../../../api/formatters/dashboard";
import theme from "../../../theme";
import { ImpactMetricData } from "../../../types/analytics";

import { GraphConfig, GraphType } from "./Utils/graphConfigs";
import { CustomResponsiveContainer } from "./Utils/graphStyleCustoms";

interface ImpactBarGraphProps {
  impactData: ImpactMetricData[];
  impactMetric: string;
}

const fakeConfig: GraphConfig = {
  title: ["Impact"],
  metrics: ["impact"],
  dataTypes: ["currencyNoDecimal"],
  color: theme.palette.error.main,
  datasetId: "productGroups",
  graphType: GraphType.Bar,
  isGroup: false,
  showAllStackedLabels: true,
};
export const ImpactBarGraph: FC<ImpactBarGraphProps> = ({
  impactData,
  impactMetric,
}) => {
  const graphValueFormatter = useGraphValueFormatter();

  return (
    <Grid item container direction={"column"} rowSpacing={1}>
      <Grid item container direction={"row"} justifyContent={"center"}>
        <IgTypography>
          Monthly {impactMetric} uplift / loss avoidance
        </IgTypography>
      </Grid>
      <Grid item>
        <CustomResponsiveContainer height={325} width="100%">
          <BarChart
            style={{ marginLeft: -14 }}
            margin={{
              top: 5,
              bottom: 5,
            }}
            data={impactData}
          >
            <CartesianGrid
              style={{ stroke: theme.palette.disabled.light }}
              vertical={false}
            />
            <XAxis
              interval={0}
              tick={(props: any) => {
                return (
                  <Text
                    fill={"#666666"}
                    maxLines={2}
                    fontSize={12}
                    fontFamily={theme.typography.fontFamily}
                    x={props.x}
                    angle={0}
                    y={props.y}
                    width={65}
                    textAnchor="middle"
                    verticalAnchor={"start"}
                  >
                    {props.payload.value}
                  </Text>
                );
              }}
              axisLine={{ stroke: theme.palette.disabled.light }}
              tickLine={false}
              dataKey="name"
            />

            <YAxis
              style={{ fontFamily: theme.typography.fontFamily, fontSize: 14 }}
              axisLine={false}
              tickLine={false}
              tickFormatter={(value: any) =>
                graphValueFormatter(true, value, fakeConfig)!
              }
            />
            <Tooltip
              contentStyle={{
                fontFamily: theme.typography.fontFamily,
                borderRadius: 5,
                fontSize: 14,
                backgroundColor: "rgba(97, 97, 97, 0.92)",
                color: "#FFF",
                border: "1px solid transparent",
              }}
              itemStyle={{ color: "#FFF" }}
              cursor={{ fill: "transparent" }}
              formatter={(value: any) =>
                graphValueFormatter(false, value, fakeConfig)!
              }
            />
            <Bar
              isAnimationActive={false}
              dataKey="value"
              radius={[10, 10, 0, 0]}
              barSize={35}
            >
              {impactData?.map((group: ImpactMetricData, index: number) => (
                <Cell
                  key={`cell-${index}`}
                  fill={
                    !group.isControlWinner
                      ? theme.palette.primary.main
                      : theme.palette.disabled.light
                  }
                />
              ))}
            </Bar>
          </BarChart>
        </CustomResponsiveContainer>
      </Grid>
    </Grid>
  );
};
